import styled from 'styled-components';

export const Content = styled.div`
  table {
    min-width: 100%;
  }
`;
